import { SortQuestionDownloadDto } from 'collaboration-service';
import * as React from 'react';
import EditPartContainer, { EditPartContainerType } from '../EditPartContainer';
import EditPartLabelAndEditor from '../EditPartLabelAndEditor';
import EditAnswers from '../Editors/EditAnswers';
import GenPropQuestion from './GenPropQuestion';
import PrePostFixQuestion from './PrePostFixQuestion';

interface PostEditQuizSortQuestionProps {
    epc: EditPartContainerType;
    registerClosed?: boolean;
}

const PostEditQuizSortQuestion = (p: PostEditQuizSortQuestionProps) => {
    const { epc, registerClosed } = p;
    return (
        <>
            <GenPropQuestion epc={epc} registerClosed={registerClosed} />
            <EditPartContainer icon="cog" title="answers" {...epc} registerClosed={false}>
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "tag", content: "answers" }, editor: <EditAnswers< SortQuestionDownloadDto> getter={x => x.possibleAnswers} noImage noIsCorrect /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
            <PrePostFixQuestion epc={epc} registerClosed={registerClosed} />
        </>
    );
}
export default PostEditQuizSortQuestion;